<template>
  <span class="selectedInfos">
    <b
    v-for="(item, index) in selectedTypes"
    :key="index"
    class="selectedInfo">
      <b>{{item.name}}</b>
      <b class="iconfont close" @click="$emit('delete', index)">&#xe605;</b>
    </b>
  </span>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: {
    'selectedTypes': {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

.selectedInfos
  .selectedInfo
    // float: left
    display: inline-block
    font-size: 12px
    color: #495060
    padding: 0px 8px
    border: 1px solid #e9eaec
    border-radius: 3px
    background: #f7f7f7
    margin: 3px 4px 3px 0
    height: 24px
    line-height: 22px
    transition: all .3s linear
    b
      font-weight: 400
    .iconfont
      color: #666
      font-size: 14px
      cursor: pointer
      margin-left: 8px
</style>
